import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiSwitchStyles = {
    styleOverrides: {
        root: {
            padding: '10px 8px 10px 7px',
            borderRadius: '8px',
            '& .MuiSwitch-switchBase': {
                padding: '15px 11px',
                borderRadius: '8px',
                '&.Mui-checked': {
                    '& + .MuiSwitch-track': {
                        backgroundColor: Palette.yellow.yellow200,
                        borderColor: Palette.yellow.yellow400,
                    },
                },
                '& .MuiSwitch-thumb': {
                    borderRadius: '4px',
                    backgroundColor: Palette.gray.gray800,
                    width: '16px',
                    height: '16px',
                },
            },
            '& .MuiSwitch-track': {
                backgroundColor: Palette.gray.gray100,
                border: `2px solid ${Palette.gray.gray300}`,
                opacity: '1 !important',
                boxSizing: 'content-box',
            },
            '&.MuiSwitch-sizeX-small, &.MuiSwitch-sizeSmall': {
                height: '20px',
                width: '32px',
                padding: '0',
                '& + .MuiTypography-root': {
                    fontSize: '14px',
                    fontWeight: '400',
                    marginLeft: '8px',
                    marginTop: '0',
                },
                '& .MuiSwitch-switchBase': {
                    padding: '4px',
                    '&.Mui-checked': {
                        transform: 'translateX(12px)',
                    },
                    '& .MuiSwitch-thumb': {
                        width: '12px',
                        height: '12px',
                        boxShadow: 'none',
                    },
                },
                '& .MuiSwitch-track': {
                    width: '32px',
                    height: '16px',
                    borderRadius: '8px',
                },
            },
        },
        sizeMedium: {
            width: '60px',
            height: '43px',
        },
    },
};
